import React from 'react';
import { Link } from 'react-router-dom';

function Team() {
    return (
        <section className="team-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1">
                        <div className="section-title-s3">
                            <div className="icon">
                                <i className="fi flaticon-suitcase"></i>
                            </div>
                            <span>Qualified Attorneys</span>
                            <h2>Meet Our Experts</h2>
                            <p>Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero sit amet adipiscing</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="team-grids team-slider owl-carousel owl-theme">
                            <div className="grid">
                                <div className="img-holder">
                                    <img src="assets/images/team/img-1.jpg" alt="" />
                                </div>
                                <div className="details">
                                    <div className="social">
                                        <ul>
                                            <li><a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><i className="ti-facebook"></i></a></li>
                                            <li><a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><i className="ti-twitter-alt"></i></a></li>
                                            <li><a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><i className="ti-linkedin"></i></a></li>
                                            <li><a href="https://pinterest.com" target="_blank" rel="noopener noreferrer"><i className="ti-pinterest"></i></a></li>
                                        </ul>
                                    </div>
                                    <h3><Link to="/team-single">Michel Troat</Link></h3>
                                    <p>Family Consultant</p>
                                </div>
                            </div>
                            <div className="grid">
                                <div className="img-holder">
                                    <img src="assets/images/team/img-2.jpg" alt="" />
                                </div>
                                <div className="details">
                                    <div className="social">
                                        <ul>
                                            <li><a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><i className="ti-facebook"></i></a></li>
                                            <li><a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><i className="ti-twitter-alt"></i></a></li>
                                            <li><a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><i className="ti-linkedin"></i></a></li>
                                            <li><a href="https://pinterest.com" target="_blank" rel="noopener noreferrer"><i className="ti-pinterest"></i></a></li>
                                        </ul>
                                    </div>
                                    <h3><Link to="/team-single">Jonathon Danial</Link></h3>
                                    <p>Business Lawyer</p>
                                </div>
                            </div>
                            <div className="grid">
                                <div className="img-holder">
                                    <img src="assets/images/team/img-3.jpg" alt="" />
                                </div>
                                <div className="details">
                                    <div className="social">
                                        <ul>
                                            <li><a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><i className="ti-facebook"></i></a></li>
                                            <li><a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><i className="ti-twitter-alt"></i></a></li>
                                            <li><a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><i className="ti-linkedin"></i></a></li>
                                            <li><a href="https://pinterest.com" target="_blank" rel="noopener noreferrer"><i className="ti-pinterest"></i></a></li>
                                        </ul>
                                    </div>
                                    <h3><Link to="/team-single">Muli Overla</Link></h3>
                                    <p>Political Expert</p>
                                </div>
                            </div>
                            <div className="grid">
                                <div className="img-holder">
                                    <img src="assets/images/team/img-4.jpg" alt="" />
                                </div>
                                <div className="details">
                                    <div className="social">
                                        <ul>
                                            <li><a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><i className="ti-facebook"></i></a></li>
                                            <li><a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><i className="ti-twitter-alt"></i></a></li>
                                            <li><a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><i className="ti-linkedin"></i></a></li>
                                            <li><a href="https://pinterest.com" target="_blank" rel="noopener noreferrer"><i className="ti-pinterest"></i></a></li>
                                        </ul>
                                    </div>
                                    <h3><Link to="/team-single">Oncon Lucy</Link></h3>
                                    <p>Family Consultant</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Team;